import { SocialMediaCategory, SocialMediaPlatform } from '@services/types/api';

export const categoryOptions = Object.values(SocialMediaCategory);
export const platformOptions = Object.values(SocialMediaPlatform);
